import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './Settings2.styles';

export interface Settings2IconProps extends WithStyles<typeof styles> {
  color?: string;
}

const Settings2IconComponent: FC<Settings2IconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <SvgIcon
      classes={{ root: classes.root }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.2632 12.9141L6.65283 13.7904C6.76865 14.0512 6.95768 14.2729 7.19698 14.4284C7.43628 14.584 7.71557 14.6667 8.00098 14.6667C8.28639 14.6667 8.56568 14.584 8.80497 14.4284C9.04427 14.2729 9.2333 14.0512 9.34912 13.7904L9.73875 12.9141C9.87745 12.6031 10.1108 12.3439 10.4054 12.1733C10.7019 12.0023 11.045 11.9294 11.3854 11.9652L12.3388 12.0667C12.6225 12.0967 12.9089 12.0437 13.1632 11.9142C13.4175 11.7847 13.6287 11.5842 13.7713 11.337C13.9141 11.09 13.9822 10.8069 13.9672 10.5219C13.9522 10.237 13.8548 9.96254 13.6869 9.73186L13.1225 8.95631C12.9215 8.6781 12.8141 8.34322 12.8158 8.00001C12.8157 7.65774 12.9241 7.32424 13.1254 7.04742L13.6899 6.27186C13.8578 6.04118 13.9551 5.76672 13.9701 5.48179C13.9851 5.19686 13.9171 4.9137 13.7743 4.66668C13.6317 4.4195 13.4205 4.219 13.1662 4.0895C12.9119 3.95999 12.6255 3.90703 12.3417 3.93705L11.3884 4.03853C11.0479 4.07428 10.7049 4.00142 10.4084 3.83038C10.1131 3.65885 9.87977 3.39825 9.74172 3.08594L9.34912 2.20964C9.2333 1.94879 9.04427 1.72715 8.80497 1.57161C8.56568 1.41607 8.28639 1.3333 8.00098 1.33334C7.71557 1.3333 7.43628 1.41607 7.19698 1.57161C6.95768 1.72715 6.76865 1.94879 6.65283 2.20964L6.2632 3.08594C6.12515 3.39825 5.89178 3.65885 5.59653 3.83038C5.30001 4.00142 4.95698 4.07428 4.61653 4.03853L3.66024 3.93705C3.37646 3.90703 3.09006 3.95999 2.83578 4.0895C2.5815 4.219 2.37025 4.4195 2.22764 4.66668C2.08486 4.9137 2.01683 5.19686 2.03182 5.48179C2.04681 5.76672 2.14417 6.04118 2.31209 6.27186L2.87653 7.04742C3.07783 7.32424 3.18622 7.65774 3.18616 8.00001C3.18622 8.34229 3.07783 8.67578 2.87653 8.9526L2.31209 9.72816C2.14417 9.95884 2.04681 10.2333 2.03182 10.5182C2.01683 10.8032 2.08486 11.0863 2.22764 11.3333C2.37039 11.5804 2.58166 11.7808 2.83591 11.9103C3.09015 12.0398 3.37648 12.0928 3.66024 12.063L4.61357 11.9615C4.95402 11.9257 5.29705 11.9986 5.59357 12.1696C5.88992 12.3407 6.12438 12.6013 6.2632 12.9141Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99979 10C9.10435 10 9.99979 9.10458 9.99979 8.00001C9.99979 6.89544 9.10435 6.00001 7.99979 6.00001C6.89522 6.00001 5.99979 6.89544 5.99979 8.00001C5.99979 9.10458 6.89522 10 7.99979 10Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
export const Settings2Icon = withStyles(styles)(Settings2IconComponent);
